import HomeIcon from "@mui/icons-material/Home";
import StoreIcon from "@mui/icons-material/Store";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ColorLensIcon from '@mui/icons-material/ColorLens';

export const menuConfig = [
    {
      label: "Home",
      icon: <HomeIcon />,
      path: "/",
    },
    {
      label: "Data Manager",
      icon: <StoreIcon />,
      subMenu: [
        {
          label: "Catalog Connect",
          path: "/data-manager/catalog-connect",
        },
        {
          label: "Data Connect",
          path: "/data-manager/data-connect",
        },
      ],
    },
    {
      label: "Analytics",
      icon: <BarChartIcon />,
      subMenu: [
        {
          label: "Overview",
          path: "/analytics",
        },
        {
          label: "Product Analytics",
          path: "/analytics/product-analytics",
        },
        {
          label: "Trends",
          path: "/analytics/trends",
        },
        {
          label: "Offline Analytics",
          path: "/analytics/offline-analytics",
        },
      ],
    },
    {
      label: "Activation",
      icon: <ShortcutIcon />,
      subMenu: [
        {
          label: "Catalog",
          path: "/activation/catalog",
        },
        {
          label: "Product Sets",
          path: "/activation/product-sets",
        },
      ],
    },
    {
      label: "Creatives",
      icon: <ColorLensIcon />,
      path: "/creatives",
      subMenu: [
        {
          label: "Edit Creatives",
          path: "/creatives/edit-creatives",
        },
        {
          label: "Template Rules",
          path: "/creatives/template-rules",
        },
      ],
    },
    {
      label: "Become Smarter",
      icon: <SmartToyIcon />,
      path: "/become-smarter"
    },
  ];